/**
 * GeoVisitorsMap — Carte mondiale des visiteurs (Leaflet).
 *
 * Utilise OpenStreetMap (tiles gratuits), aucune clé API.
 * Affiche des cercles proportionnels au nombre de visites par point géo.
 *
 * V35.10 — Localisation visiteurs.
 */
import React from 'react';
import { MapContainer, TileLayer, CircleMarker, Tooltip } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';

export default function GeoVisitorsMap({ points = [], height = 360 }) {
  if (!points || points.length === 0) {
    return (
      <div
        className="flex items-center justify-center bg-slate-50 dark:bg-slate-900/40 rounded-xl border border-dashed border-slate-200 dark:border-slate-700"
        style={{ height }}
        data-testid="geo-map-empty"
      >
        <p className="text-sm text-slate-500 dark:text-slate-400">
          Aucune donnée de localisation sur la période.
        </p>
      </div>
    );
  }

  const maxVisits = Math.max(...points.map((p) => p.visits || 1), 1);

  // Échelle des cercles : 6 → 22 px
  const radiusFor = (v) => 6 + Math.round((v / maxVisits) * 16);

  return (
    <div
      className="rounded-xl overflow-hidden border border-slate-200 dark:border-slate-700 shadow-sm"
      style={{ height }}
      data-testid="geo-visitors-map"
    >
      <MapContainer
        center={[20, 5]}
        zoom={2}
        minZoom={2}
        maxZoom={6}
        style={{ height: '100%', width: '100%', background: '#f8fafc' }}
        scrollWheelZoom={false}
        worldCopyJump
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        />
        {points.map((p, i) => (
          <CircleMarker
            key={`${p.lat}-${p.lng}-${i}`}
            center={[p.lat, p.lng]}
            radius={radiusFor(p.visits)}
            pathOptions={{
              color: '#0B3C5D',
              fillColor: '#f59e0b',
              fillOpacity: 0.7,
              weight: 1.5,
            }}
          >
            <Tooltip direction="top" offset={[0, -4]} opacity={0.95}>
              <div className="text-xs font-medium">
                <div className="font-bold">
                  {p.city ? `${p.city} · ` : ''}
                  {p.country || 'Inconnu'}
                </div>
                <div className="text-slate-600">
                  {p.visits} visite{p.visits > 1 ? 's' : ''}
                </div>
              </div>
            </Tooltip>
          </CircleMarker>
        ))}
      </MapContainer>
    </div>
  );
}
